<template>
  <ContentDoc v-slot="{ doc }">
    <app-container>
      <app-container-header
        :title="doc.title"
        :description="doc.description"
        :subtitle="subtitle"
        :breadcrumbs="[
          {
            disabled: false,
            exact: true,
            title: 'Home',
            to: { name: 'index' },
          },
          {
            disabled: false,
            exact: true,
            title: 'Website Analyzer',
            to: { name: 'products-website-analyzer' },
          },
          {
            disabled: true,
            exact: true,
            title: doc.title,
          },
        ]"
      />
      <v-alert class="mb-4" variant="tonal" type="info">
        To use our awesome API, an active pay-as-you-go
        <nuxt-link plain :to="{ name: 'user-subscription' }">
          subscription
        </nuxt-link>
        &nbsp;is required
      </v-alert>

      <article>
        <ContentRenderer :value="doc" />
        <code-tabs class="w-100" :items="codeTabsItems" />
      </article>
    </app-container>
  </ContentDoc>
</template>

<script setup>
const codeTabsItems = ref([])

const route = useRoute()

const { data: page } = await useAsyncData(route.path, () =>
  queryContent(route.path).findOne()
)

const title = page.value.head?.title || page.value.title
const description = page.value.head?.description || page.value.description
const updatedAt = page.value.updatedAt ? new Date(page.updatedAt) : new Date()

useSeoMeta({
  title,
  description,
  ogDescription: description,
  ogTitle: title,
  updatedAt,
})

const subtitle = updatedAt.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
})

codeTabsItems.value = [
  {
    label: 'JavaScript',
    path: 'products/website-analyzer/api-js',
  },
  {
    label: 'Go',
    path: 'products/website-analyzer/api-go',
  },
  {
    label: 'Python',
    path: 'products/website-analyzer/api-python',
  },
  {
    label: 'Ruby',
    path: 'products/website-analyzer/api-ruby',
  },
]
</script>
